import { ComponentsOverrides, ComponentsProps, ComponentsVariants, CssVarsTheme } from '@mui/material/styles';

export const MuiIconButton: {
  defaultProps?: ComponentsProps['MuiIconButton'];
  styleOverrides?: ComponentsOverrides<CssVarsTheme>['MuiIconButton'];
  variants?: ComponentsVariants['MuiIconButton'];
} = {
  styleOverrides: {
    root: {
      borderRadius: '8px',
      minWidth: '0'
    },
    sizeSmall: {
      height: '32px',
      width: '32px'
    },
    sizeMedium: {
      height: '40px',
      width: '40px'
    },
    sizeLarge: {
      height: '48px',
      width: '48px'
    }
  }
};
